import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-socio-emocional',
  templateUrl: './socio-emocional.component.html',
  styleUrls: ['./socio-emocional.component.scss']
})
export class SocioEmocionalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
